<template>
  <aside
    class="menu-component"
    :class="{ 'menu-collapsed': !isMenuOpen }"
  >
    <!-- 顶部品牌区 -->
    <div class="menu-brand">
      <svg viewBox="0 0 48 48" width="30" height="30" aria-hidden="true">
        <defs>
          <linearGradient id="menu-logo-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#4E93FF"/>
            <stop offset="1" stop-color="#165DFF"/>
          </linearGradient>
        </defs>
        <path d="M24 2.5 L43 9.5 V22 C43 33.2 34.8 41.6 24 45.5 C13.2 41.6 5 33.2 5 22 V9.5 Z" fill="url(#menu-logo-grad)"/>
        <circle cx="24" cy="22" r="9.5" fill="none" stroke="#fff" stroke-width="2.6" opacity="0.92"/>
        <circle cx="24" cy="22" r="3.6" fill="#fff"/>
        <path d="M24 22 L33.5 31.5" stroke="#fff" stroke-width="2.8" stroke-linecap="round"/>
      </svg>
      <div class="menu-brand-text">
        <span class="menu-brand-name">哨兵安全监控</span>
        <span class="menu-brand-sub">SENTINEL SECURITY</span>
      </div>
    </div>

    <nav class="menu-nav">
      <ul class="menu-list">
        <li
          v-for="menu in menuList"
          :key="menu.path || menu.menu_id"
          class="menu-item"
          :class="{ 'active': menu.isParent ? isChildActive(menu) : $route.path === menu.path, 'parent-item': menu.isParent }"
        >
          <!-- 父菜单项 -->
          <div
            v-if="menu.isParent"
            class="menu-link parent-link"
            @click="toggleSubMenu(menu)"
          >
            <i :class="menu.icon"></i>
            <span class="menu-text">{{ menu.name }}</span>
            <i
              class="el-icon-arrow-right menu-arrow"
              :class="{ 'rotate': isSubMenuOpen(menu) }"
            ></i>
          </div>
          <!-- 子菜单项 -->
          <router-link
            v-else
            :to="menu.path"
            class="menu-link"
            @click.native="handleMenuClick"
          >
            <i :class="menu.icon"></i>
            <span class="menu-text">{{ menu.name }}</span>
          </router-link>

          <!-- 子菜单列表 -->
          <ul
            v-if="menu.isParent && menu.children && menu.children.length > 0"
            class="sub-menu-list"
            :class="{ 'show': isSubMenuOpen(menu) }"
          >
            <li
              v-for="subMenu in menu.children"
              :key="subMenu.url || subMenu.path || subMenu.menu_id"
              class="sub-menu-item"
              :class="{ 'active': $route.path === `/${subMenu.url}` }"
            >
              <router-link :to="`/${subMenu.url}`" class="sub-menu-link" @click.native="handleMenuClick">
                <i :class="subMenu.icon"></i>
                <span class="sub-menu-text">{{ subMenu.name }}</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <!-- 底部版本信息 -->
    <div class="menu-footer">
      <span>v2.0 · 工业安全守护</span>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'MenuComponent',
  props: {
    isDesktop: {
      type: Boolean,
      default: true
    },
    isMenuOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 存储当前展开的子菜单ID
      openSubMenus: []
    }
  },
  computed: {
    // 从Vuex store中获取菜单列表
    menuList() {
      return this.$store.state.menuList.length > 0 ? this.$store.state.menuList : [
        { path: '/home', name: '主页', icon: 'el-icon-house' }
      ];
    }
  },
  mounted() {
    this.expandCurrentParent()
  },
  watch: {
    // 菜单数据（登录后/缓存恢复后）更新时，确保当前路由所属父级展开
    menuList() {
      this.expandCurrentParent()
    },
    '$route'() {
      this.expandCurrentParent()
    }
  },
  methods: {
    // 当前路由是否命中某父级分组的子项
    isChildActive(menu) {
      return (menu.children || []).some(c => this.$route.path === `/${c.url}`)
    },
    // 进入子页时确保其所属父级分组展开（其余分组保持收起）
    expandCurrentParent() {
      const list = this.menuList || []
      list.forEach(menu => {
        if (menu.isParent && this.isChildActive(menu)) {
          const menuId = menu.path || menu.menu_id
          if (!this.openSubMenus.includes(menuId)) this.openSubMenus.push(menuId)
        }
      })
    },
    // 切换子菜单展开状态
    toggleSubMenu(menu) {
      const menuId = menu.path || menu.menu_id;
      const index = this.openSubMenus.indexOf(menuId);
      if (index > -1) {
        this.openSubMenus.splice(index, 1);
      } else {
        this.openSubMenus.push(menuId);
      }
    },
    // 检查子菜单是否展开
    isSubMenuOpen(menu) {
      const menuId = menu.path || menu.menu_id;
      return this.openSubMenus.includes(menuId);
    },
    // 处理菜单项点击事件
    handleMenuClick() {
      // 手机端点击菜单项后关闭菜单
      if (!this.isDesktop) {
        this.$emit('menu-click');
      }
    }
  }
}
</script>

<style scoped lang="css">
.menu-component {
  /* 深蓝黑渐变，取代旧的黑底图片背景 */
  background: linear-gradient(180deg, #1C2A4A 0%, #131E38 55%, #0E162B 100%);
  color: #fff;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
}

/* 宽度：展开 220px，收起 0（桌面/手机统一） */
.menu-component:not(.menu-collapsed) {
  width: 220px;
}

.menu-component.menu-collapsed {
  width: 0;
}

/* ---------- 顶部品牌区 ---------- */
.menu-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  white-space: nowrap;
  overflow: hidden;
}

.menu-brand svg {
  flex-shrink: 0;
  filter: drop-shadow(0 2px 6px rgba(22, 93, 255, 0.5));
}

.menu-brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.menu-brand-name {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
}

.menu-brand-sub {
  font-size: 9px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 3px;
}

/* ---------- 导航区 ---------- */
.menu-nav {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 0;
}

.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-item {
  margin: 0 0 2px;
  padding: 0 10px;
}

/* 菜单链接（圆角块） */
.menu-link {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
}

.menu-link:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.menu-link i {
  font-size: 16px;
  margin-right: 10px;
  color: rgba(255, 255, 255, 0.65);
  transition: color 0.2s ease;
}

.menu-link:hover i {
  color: #fff;
}

.menu-text {
  font-size: 13.5px;
  flex: 1;
  letter-spacing: 0.5px;
}

/* 激活态：渐变主色块 + 左侧指示条 */
.menu-item.active .menu-link {
  background: linear-gradient(90deg, rgba(22, 93, 255, 0.35) 0%, rgba(22, 93, 255, 0.18) 100%);
  color: #fff;
  font-weight: 600;
}

.menu-item.active .menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 18px;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(180deg, #4E93FF, #165DFF);
}

.menu-item.active .menu-link i {
  color: #fff;
}

/* 箭头 */
.menu-arrow {
  font-size: 12px !important;
  margin-left: auto !important;
  margin-right: 0 !important;
  color: rgba(255, 255, 255, 0.5) !important;
  transition: transform 0.3s ease;
}

.menu-arrow.rotate {
  transform: rotate(90deg);
}

/* 子菜单 */
.sub-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.sub-menu-list.show {
  max-height: 500px;
}

.sub-menu-item.active .sub-menu-link {
  background: linear-gradient(90deg, rgba(22, 93, 255, 0.3) 0%, rgba(22, 93, 255, 0.12) 100%);
  color: #fff;
}

.sub-menu-link {
  display: flex;
  align-items: center;
  padding: 9px 14px 9px 44px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-size: 13px;
}

.sub-menu-link:hover {
  background-color: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.sub-menu-link i {
  font-size: 13px;
  margin-right: 8px;
  color: rgba(255, 255, 255, 0.5);
}

/* 底部版本 */
.menu-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
}

/* 滚动条 */
.menu-nav::-webkit-scrollbar {
  width: 4px;
}
.menu-nav::-webkit-scrollbar-track {
  background: transparent;
}
.menu-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 2px;
}
.menu-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 响应式 */
@media (max-width: 768px) {
  .menu-component {
    position: fixed;
    top: 64px;
    left: 0;
    bottom: 0;
    z-index: 999;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.2);
    height: calc(100% - 64px);
  }

  .menu-component:not(.menu-collapsed) {
    width: 240px;
  }

  .menu-link {
    padding: 12px 14px;
  }

  .menu-link i {
    font-size: 17px;
  }

  .menu-text {
    font-size: 15px;
  }
}

@media (min-width: 769px) {
  .menu-component {
    flex-shrink: 0;
    height: 100%;
  }
}
</style>
